import React from 'react';
import { SEO } from './components/SEO';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { Services } from './components/Services';
import { About } from './components/About';
import { Contact } from './components/Contact';
import { Footer } from './components/Footer';
export function App() {
  return <>
      <SEO data-id="element-0" />
      <div className="min-h-screen flex flex-col font-sans selection:bg-blue-200 selection:text-blue-900" data-id="element-1">
        <Header data-id="element-2" />
        <main className="flex-grow" data-id="element-3">
          <Hero data-id="element-4" />
          <Services data-id="element-5" />
          <About data-id="element-6" />
          <Contact data-id="element-7" />
        </main>
        <Footer data-id="element-8" />
      </div>
    </>;
}